import React from 'react';

// Birden fazla serbest metin değeri girmek için ekle/kaldır butonlu input listesi.
const MultiTextInput = ({ values, onChange, placeholder }) => {
    const list = values && values.length > 0 ? values : [''];

    const handleChange = (idx, val) => {
        const updated = [...list];
        updated[idx] = val;
        onChange(updated);
    };

    const handleAdd = () => {
        onChange([...list, '']);
    };

    const handleRemove = (idx) => {
        const updated = list.filter((_, i) => i !== idx);
        onChange(updated.length > 0 ? updated : ['']);
    };

    return (
        <div className="d-flex flex-column gap-2">
            {list.map((val, idx) => (
                <div className="d-flex gap-2" key={idx}>
                    <input
                        type="text"
                        className="form-control"
                        value={val}
                        placeholder={placeholder}
                        onChange={(e) => handleChange(idx, e.target.value)}
                    />
                    {list.length > 1 && (
                        <button type="button" className="btn btn-light" onClick={() => handleRemove(idx)}>
                            <i className="feather-x"></i>
                        </button>
                    )}
                    {idx === list.length - 1 && (
                        <button type="button" className="btn btn-light" onClick={handleAdd}>
                            <i className="feather-plus"></i>
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
};

export default MultiTextInput;
